<script setup>
import Toast from '@/Layout/Errors/Toast.vue'
import { useErrorsStore } from '@/Stores/errors'
const errors = useErrorsStore()

function dismissError(id) {
	setTimeout(() => {
		errors.removeError({id})
	}, 500)
}
</script>

<template>
	<div class="relative mx-auto w-full max-w-5xl z-50">
		<div class="fixed top-0 left-0 right-0 pt-8">
			<Toast 
				v-for="error in errors.errors"
				:key="error.id"
				@dismiss-error="dismissError"
				:error="error"
			/>
		</div>
	</div>
</template>

